import React from "react";
import "../css/Inicio.css"

function Inicio() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "80vh",
        background: "linear-gradient(to right, #f8f9fa, #e9ecef)",
      }}
    >
      <div
        className="card shadow-lg text-center p-5"
        style={{
          borderRadius: "20px",
          maxWidth: "700px",
          width: "100%",
          animation: "fadeIn 0.8s ease-out",
        }}
      >
        <img
          src="https://i.ibb.co/rGr0HKNN/logo2.png"
          alt="Logo TuRips"
          className="img-fluid mx-auto mb-4"
          style={{ width: "140px" }}
        />
        <h1 className="text-dark mb-4" style={{ color:"#003F88", fontSize: "2.5rem", fontWeight: "600" }}>
          Bienvenido a TuRips
        </h1>
        <p className="text-muted" style={{ fontSize: "1.2rem" }}>
          Sistema de validación, carga y administración de RIPS en formato JSON.
        </p>
      </div>
    </div>
  );
}

export default Inicio;
